import React, { useState } from "react";
import { ProductPrice} from "../../../../components";
import { translate } from "../../../../services";
import { caretDownIconNew } from "../../../../../style/images";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { styled } from '@mui/system';


const CustomIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#f5f8fa',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto #333333',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
    ...theme.applyStyles('dark', {
      backgroundColor: '#30404d',
    }),
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
    ...theme.applyStyles('dark', {
      background: 'rgba(57,75,89,.5)',
    }),
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
    backgroundColor: '#394b59',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
  }),
}));

const CustomCheckedIcon = styled(CustomIcon)({
  backgroundColor: '#333333',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&::before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#333333',
  },
});

function CustomRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<CustomCheckedIcon />}
      icon={<CustomIcon />}
      {...props}
    />
  );
}

export const FGcomponent = (props) =>{
    
    const [selectedOption, setSelectedOption] = useState(props.selectedOption);
    const [fgCodeDrawer, setFgCodeDrawer] = useState(false);

    const handleOptionChange = ( changeEvent, products ) => {
        setSelectedOption(changeEvent.target.value);
        props.setSelectedOption(changeEvent.target.value)
      }
    
    const handleFgCodeDrawer = ()=>{
      setFgCodeDrawer(!fgCodeDrawer);
    }

    const {FGDescription, FG, showConfiguratorButtonAtTop, user, isPopup, template, products, fromSearch} = props;
    const FGdescriptionLabel= '出厂组装成品型号：';
    const FGcodelabel='订货号 FG: ';
    const FGcode=FG && FG.length>0?FG: '待开';
    const fromCbol = user.authenticationType === 'Cbol';
    const apttusReconfig = user.authenticationType === 'Apttus' && user.properties["Action"] === "Reconfig";
    const cartProducts = isPopup ? { ...products, configuration: template } : products;
    const product={...cartProducts, FG:FG};

    return (props.mobileView?<>
      {!fgCodeDrawer ? <div className="fgcode-drawer">
      <div className='fgcode-drawer-component'>
      <div ><span>{FGcodelabel}</span><span>{FGcode}</span></div>
        <Box component="img" src={caretDownIconNew} className={"arrow-icon"} onClick={handleFgCodeDrawer}></Box>
      </div>
    </div>:<div className='delivery'>
        <div className="delivery-content">
        <div ><span >{FGdescriptionLabel}</span><span>{FGDescription}</span></div>
    <div ><span >{FGcodelabel}</span><span>{FGcode}</span></div>
    <div>
        <div>
          <ProductPrice
            translationPhrase={"Total_"}
            showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
            fromConfigFooter
            excludeLooseAccPrice
            fromCart={false || fromCbol || apttusReconfig}
            priceSize="big"
            product={product}
            skipLooseAcc={true}
            fromSearch={fromSearch}
          />
        </div>
      </div>
      {!products.code?.startsWith('V') && <div className="ready-assembly-radio">
      { translate( "Need delivery as finish goods?" ) }

      <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectedOption}
        onChange={(e)=>{handleOptionChange(e, products)}}
      >
        <FormControlLabel value="YES" control={<CustomRadio />} label={translate("YES")} />
        <FormControlLabel value="NO" control={<CustomRadio />} label={translate("NO")} />
        </RadioGroup>
    </FormControl>
    </div>}
        </div>
        <Box component="img" src={caretDownIconNew} className={"arrow-icon"} onClick={handleFgCodeDrawer}></Box>
    </div>}</>
    :<div className='delivery'>
        <div className="delivery-content">
        <div ><span >{FGdescriptionLabel}</span><span>{FGDescription}</span></div>
    <div ><span>{FGcodelabel}</span><span>{FGcode}</span></div>
    <div>
        <div>
          <ProductPrice
            translationPhrase={"Total_"}
            showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
            fromConfigFooter
            excludeLooseAccPrice
            fromCart={false || fromCbol || apttusReconfig}
            priceSize="big"
            product={product}
            skipLooseAcc={true}
            fromSearch={fromSearch}
          />
        </div>
      </div>
    {!products.code?.startsWith('V') && <div className="ready-assembly-radio">
      { translate( "Need delivery as finish goods?" ) }

    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectedOption}
        onChange={(e)=>{handleOptionChange(e, products)}}
      >
        <FormControlLabel value="YES" control={<CustomRadio />} label={translate("YES")} />
        <FormControlLabel value="NO" control={<CustomRadio />} label={translate("NO")} />
        </RadioGroup>
    </FormControl>
    </div>}
        </div>

    </div>)
}